/**
 * Metadata API Service
 * Public, unauthenticated reference data (FAQs, property types, amenities, etc.)
 */

import { request, unwrapPatternA } from './apiClient';

const metadataService = {
    /**
     * Get platform FAQs
     * @returns {Promise<Array<{id, question, answer, category, sort_order}>>}
     */
    getFaqs: async () => {
        const data = await request('/metadata/faqs');
        return unwrapPatternA(data) || [];
    },

    /**
     * Get the platform's documents typically requested for a rental application
     * @returns {Promise<Array<{type: string}>>}
     */
    getApplicationRequirements: async () => {
        const data = await request('/metadata/application-requirements');
        return unwrapPatternA(data) || [];
    }
};

export default metadataService;
